var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBinoculars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    className: "svg-inline--fa",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 33 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 33,
    height: 29,
    transform: "translate(-0.124 0)",
    fill: "current"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-jumelles",
    transform: "translate(-0.137 0.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_36",
    "data-name": "Groupe 36",
    transform: "translate(0.261 -0.608)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_186",
    "data-name": "Trac\\xE9 186",
    d: "M529.971,354.609a.638.638,0,1,0-.638-.638.639.639,0,0,0,.638.638",
    transform: "translate(-504.213 -336.167)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_187",
    "data-name": "Trac\\xE9 187",
    d: "M140.638,354.609a.638.638,0,1,0-.638-.638.639.639,0,0,0,.638.638",
    transform: "translate(-133.52 -336.167)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_188",
    "data-name": "Trac\\xE9 188",
    d: "M137.3,364.693a.958.958,0,0,0-1.206,1.488,2.871,2.871,0,0,1-1.8,5.106.958.958,0,0,0,0,1.915,4.786,4.786,0,0,0,3.01-8.509",
    transform: "translate(-127.172 -346.781)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_189",
    "data-name": "Trac\\xE9 189",
    d: "M32.88,18.871a7.366,7.366,0,0,0-.682-1.391l-4.25-9.37v0l0-.006-1.6-3.522a.957.957,0,0,0-.067-.123,4.179,4.179,0,0,0-1.895-1.584h0a2.873,2.873,0,0,0-5.745,0V6.7s0,0,0,0h0V7.66H14.682V2.873a2.873,2.873,0,1,0-5.745,0h0A4.178,4.178,0,0,0,7.042,4.458a.953.953,0,0,0-.067.123L5.378,8.1l0,.008h0l-4.25,9.37a7.341,7.341,0,1,0,13.558,3.9v-1.6H18.64v1.592s0,0,0,0a7.341,7.341,0,1,0,14.24-2.513M20.555,11.809A3.511,3.511,0,0,1,26.29,9.094l2.5,5.505a7.344,7.344,0,0,0-8.233,1.846Zm4.552-5.325a5.419,5.419,0,0,0-4.552,1.192V6.7a2.235,2.235,0,0,1,4.079-1.259ZM21.512,1.915a.959.959,0,0,1,.908.655,4.121,4.121,0,0,0-1.865.638V2.873a.959.959,0,0,1,.958-.958M18.64,15.32H14.682V9.575H18.64ZM7.031,9.094a3.511,3.511,0,0,1,5.736,2.716v4.636A7.344,7.344,0,0,0,4.534,14.6Zm4.778-7.179a.959.959,0,0,1,.958.958v.335A4.122,4.122,0,0,0,10.9,2.57a.959.959,0,0,1,.908-.655m-1.723,2.6A2.234,2.234,0,0,1,12.767,6.7v.973A5.42,5.42,0,0,0,8.215,6.484l.473-1.042a2.246,2.246,0,0,1,1.4-.928M7.341,26.81a5.424,5.424,0,0,1-4.568-8.355l0,0A5.426,5.426,0,1,1,7.341,26.81m7.341-9.575H18.64v.638H14.682Zm11.3,9.575a5.432,5.432,0,0,1-5.426-5.425h0v0a5.427,5.427,0,0,1,9.991-2.93h0l0,0A5.427,5.427,0,0,1,25.98,26.81",
    transform: "translate(-0.223 0.249)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_190",
    "data-name": "Trac\\xE9 190",
    d: "M527.653,365.764a4.827,4.827,0,0,0-1.019-1.137.957.957,0,0,0-1.206,1.487,2.916,2.916,0,0,1,.615.686,2.874,2.874,0,0,1-2.419,4.423.958.958,0,0,0,0,1.915,4.786,4.786,0,0,0,4.03-7.374",
    transform: "translate(-497.866 -346.718)",
    fill: "current"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinoculars);
export default __webpack_public_path__ + "static/media/binoculars.bdba556142e6decf3347599d2f2c03bb.svg";
export { ForwardRef as ReactComponent };